//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../Mechatronics/Mechatronics.CouplingBuilder.js";
import "../no/Expression.js";
import "../no/Display.js";
import "../no/Expression.js";
let d=[[[0,"AddCamDiskToMasterJointOption",1,0],[0,"CamDiskRefPoint",1,"Point",0],[0,"CamDiskType",1,0],[0,"CamProfile",1,"Mechatronics.CamProfile",0],[0,"CreateCamDisk",1,0],[1,"ExtrudeLength",0,"Expression",0],[0,"LayerSettings",0,"Display.LayerSettingsBuilder",0],[0,"MasterAxisType",1,0],[1,"MasterOffset",0,"Expression",0],[1,"MasterScaleFactor",0,"Expression",0],[0,"MotionProfile",1,"Mechatronics.MotionProfile",0],[0,"RefPointOption",1,0],[0,"SlaveAxisType",1,0],[1,"SlaveOffset",0,"Expression",0],[1,"SlaveScaleFactor",0,"Expression",0]],[[["count"],"GetCurveFeatures",{R_:{curveFeatures:"Features.Feature[]"}},0,0],[["curveFeatures"],"SetCurveFeatures",{},1,0],[["curveFeature"],"AddCurveFeature",{},1,0],[[],"GetExtrudeFeature",{R_:{extrudeFeature:"Features.Feature"}},0,0],[["extrudeFeature"],"SetExtrudeFeature",{},1,0],[[],"ExecuteCamDisk",{},0,0],[[],"UpdateCamDisk",{},0,0]],[]];
SPLM.Mechatronics.CamBuilder = class extends SPLM.Mechatronics.CouplingBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.CamBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.CamBuilder.AxisJointType = Object.freeze({
    "Linear" : "Linear", "Angular" : "Angular"});

SPLM.Mechatronics.CamBuilder.CreateCamDiskType = Object.freeze({
    "Curve" : "Curve", "Solid" : "Solid"});

SPLM.Mechatronics.CamBuilder.AddCamDiskToMasterOption = Object.freeze({
    "None" : "None", "Edit" : "Edit", "Replace" : "Replace"});

export default SPLM;